<script setup>
import { ref, computed } from 'vue'

import ImageMin from '@/images/ImageMin.vue'
import Image_Download from '@/assets/dwnld.png';
import DwnldSvg from '@/assets/svgs/DwnldSvg.vue'
import Age_E_img from '@/assets/img/icons/age_E.webp'

import { getStarsNumberOrString, getRewievsComments, getIsArabicLayoutDirection } from '@/utils/additional.js'

const props = defineProps({
   commentsCount: String,
   titleComments: String,

   appSize: String,

   addDownloadCaption: String,
   addDownloadTitle: String,

   ageLimitImg: String,
   ageLimitDescription: String, //Everyone

   whoСhooses: String,
   additionalRatings: [String, null],


   firstColor: {
      type: String,
      default: null
   },
   secondaryColor: {
      type: String,
      default: null
   },
})

import { useDataScore } from '@/stores/dataScore.js'
const scoreStore = useDataScore();
// scoreStore.init()

function getStars(numberString) {
   return getStarsNumberOrString(numberString, props.additionalRatings)
   // return `${number || 4.8}`.replace('.', ',')
}

function getRewiews(numberString) {
   return `${numberString}`
   // return `${(number * 1.06739).toFixed(1)}`.replace('.', ',')
}

const secondaryTextColor = computed(() => {
   return props.secondaryColor ? `color: ${props.secondaryColor};` : ''
})

</script>

<template>
   <div class="block__app_info" :style="firstColor ? `color: ${firstColor}; fill: ${firstColor};` : ''">
      <div :class="'block__app_info--inner_slide'">

         <div class="block__app_info--item_common">
            <div class="block__app_info--item_inner">
               {{ getStars(scoreStore.totalScore) }}<i class="google-material-icons" aria-hidden="true">star</i>
            </div>
            <div class="block__app_info--item_inner additional_text" :style="secondaryTextColor">
               <!-- {{ getRewiews(props.commentsCount) }} -->
               <!-- {{ props.titleComments }} -->
               {{ getRewievsComments(props.commentsCount, props.titleComments) }}
            </div>
         </div>


         <div class="block__app_info--item_common">
            <div class="block__app_info--item_inner">
               {{ props.addDownloadCaption }}
            </div>
            <div class="block__app_info--item_inner additional_text" :style="secondaryTextColor">
               {{ props.addDownloadTitle }}
            </div>
         </div>

         <div class="block__app_info--item_common">
            <div class="block__app_info--item_inner">
               <div class="block__app_info--item_inner">
                  <!-- <img :src="Image_Download" style="width: 24px;"> -->
                  <DwnldSvg />
               </div>
            </div>
            <div class="block__app_info--item_inner additional_text" :style="secondaryTextColor">
               {{ props.appSize }}
            </div>
         </div>


         <div class="block__app_info--item_common">
            <div class="block__app_info--item_inner">
               <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" xml:space="preserve">
                  <rect fill="transparent" width="20" height="20"></rect>
                  <path stroke="transparent" fill="currentColor"
                     d="M10.54,11.09L8.66,9.22l-1.02,1.02l2.9,2.9l5.8-5.8l-1.02-1.01L10.54,11.09z M15.8,16.24H8.2L4.41,9.66L8.2,3h7.6l3.79,6.66 L15.8,16.24z M17,1H7L2,9.66l5,8.64V23l5-2l5,2v-4.69l5-8.64L17,1z">
                  </path>
               </svg>
            </div>
            <div class="block__app_info--item_inner additional_text" :style="secondaryTextColor">
               {{ props.whoСhooses }}
            </div>
         </div>

         <div class="block__app_info--item_common">
            <div class="block__app_info--item_inner">
               <div class="block__app_info--item_inner">
                  <!-- <img :src="Image_Download" style="width: 24px;"> -->
                  <img :src="Age_E_img" style="width: 16px;max-width: 16px;">
               </div>
            </div>
            <div class="block__app_info--item_inner additional_text" :style="secondaryTextColor">
               <div>
                  {{ props.ageLimitDescription }}
               </div>
            </div>
         </div>


      </div>
   </div>
</template>

<style lang="scss">
.block_ {

   // .block__app_info
   &_app_info {
      height: 64px;
      // margin: 16px 0 24px -24px;
      margin: 16px 0 24px 0px;
      padding: 12px 0;
      width: 100vw;

      &--inner_slide {
         align-items: center;
         display: flex;
         overflow: auto;
         overflow-y: scroll;
         scrollbar-width: none;
         -ms-overflow-style: none;
      }

      &--inner_slide::-webkit-scrollbar {
         display: none;
      }

      &--inner_slide::before {
         // width: 24px;
         // content: " ";
         // display: block;
         // flex-shrink: 0;
      }

      &--item_common {
         padding: 0 16px;
         position: relative;
         text-align: center;
         /* min-width: 220px; */
         width: inherit;
         display: inline-block;
      }

      // .block__app_info--item_common:no/t(:first-child)::before {
      // &--item_common:not(:first-child)::before {
      //    background-color: var(--data_color_additional_text);
      //    content: "";
      //    display: block;
      //    height: 24px;
      //    left: 0;
      //    position: absolute;
      //    top: calc(50% - 12px);
      //    width: 1px;
      // }

      &--item_inner {
         white-space: nowrap;
         display: flex;
         flex-direction: row;
         justify-content: center;
         height: 24px;
         align-items: center;
         font-size: calc(1.0rem * var(--app-font-size));
         // font-size: calc(1.125rem * var(--app-font-size));
      }

   }
}

.google-material-icons {
   font-family: 'Google Material Icons';
   font-weight: normal;
   font-style: normal;
   font-size: 12px;
   line-height: 1;
   letter-spacing: normal;
   text-transform: none;
   display: inline-block;
   white-space: nowrap;
   word-wrap: normal;
   direction: ltr;
   -webkit-font-feature-settings: 'liga';
   -webkit-font-smoothing: antialiased;
}
</style>
